// GenericErrorBoundary — reutilizável para qualquer componente que pode throw no render.
// Recebe:
//   fallback?  — ReactNode alternativo (substitui o card padrão)
//   onReset?   — callback chamado pelo botão "Tentar de novo"
// Reset automático quando `resetKey` muda (equivalente ao ChatErrorBoundary).
import { Component } from 'react';

export default class GenericErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[GenericErrorBoundary] render falhou', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  handleReset = () => {
    this.setState({ error: null });
    this.props.onReset?.();
  };

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          role="alert"
          className="m-3 rounded-apolo-md border border-apolo-error/40 bg-apolo-surface1 p-3 text-sm text-apolo-textSecondary"
        >
          <p className="font-medium text-apolo-textPrimary">Este componente falhou ao renderizar.</p>
          <pre className="mt-1 max-h-24 overflow-auto whitespace-pre-wrap break-words rounded bg-apolo-surface2 p-2 text-xs text-apolo-textTertiary">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <button
            type="button"
            onClick={this.handleReset}
            className="mt-2 inline-flex h-7 items-center rounded-apolo-md border border-apolo-borderSubtle px-3 text-xs font-medium text-apolo-textPrimary transition hover:bg-apolo-surface2 focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accent/50"
          >
            Tentar de novo
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
